<template>
  <b-dropdown ref="dropdown" aria-role="list">
    <template #trigger="{ active }">
      <b-tooltip :label="tooltipLabel" position="is-top">
        <b-button
          class="is-success"
          label="Générer un start et un finish"
          type="is-primary"
          :icon-right="active ? 'angle-up' : 'angle-down'"
          :disabled="disabledTrigger"
        />
      </b-tooltip>
    </template>
    <b-dropdown-item custom aria-role="menuitem">
      <b-field label="Route complète">
        <b-select
          v-model="selectedStagePathId"
          placeholder="Sélectionner une route complète"
          expanded
        >
          <option v-for="path in availableStagePaths" :key="path.id" :value="path.id">
            {{ path.name }}
          </option>
        </b-select>
      </b-field>
      <b-field>
        <b-button type="is-primary" :loading="loading" :disabled="disabledSubmit" @click="generate">
          Générer
        </b-button>
      </b-field>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { WAYPOINT_ROLE_FINISH, WAYPOINT_ROLE_START } from '@constants/waypoint/role'
import { mapActions } from 'vuex'

export default {
  name: 'LiveStageWaypointGenerateStartFinish',

  props: {
    stagePaths: {
      type: Array,
      required: true,
    },
    stageWaypoints: {
      type: Array,
      required: true,
    },
    liveCategories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      selectedStagePathId: null,
      availableStagePaths: [],
    }
  },
  watch: {
    async stagePaths() {
      await this.load()
    },

    async stageWaypoints() {
      await this.load()
    },
  },

  computed: {
    tooltipLabel() {
      return this.disabledTrigger
        ? 'Cette étape a déjà au moins un start ou un finish'
        : 'Générer un start et un finish depuis une route complète'
    },

    disabledTrigger() {
      return !this.availableStagePaths.length
    },

    disabledSubmit() {
      return this.loading || !this.selectedStagePathId
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async generate() {
      this.loading = true

      try {
        const waypoints = await this.$services.liveStageWaypointService.generateStartFinish(
          this.selectedStagePathId,
        )

        this.$emit('generate', waypoints)

        this.$refs.dropdown.toggle()

        this.addToastMessage({
          text: `Les waypoints start et finish ont été générés.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message || 'Une erreur interne est survenue.',
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },

    async load() {
      this.availableStagePaths = []

      const paths = []
      for (const path of this.stagePaths) {
        if (path.liveCategoryId) {
          const category = this.liveCategories.find(({ id }) => id === path.liveCategoryId)
          if (category && !category.hasTrackRules) {
            continue
          }
        }

        paths.push(path)
      }

      const availableRoles = await Promise.all(paths.map(this.fetchAvailableRoles))

      this.availableStagePaths = paths.filter((_, index) => {
        const roles = availableRoles[index]
        return (
          Array.isArray(roles) &&
          roles.includes(WAYPOINT_ROLE_START) &&
          roles.includes(WAYPOINT_ROLE_FINISH)
        )
      })

      if (this.availableStagePaths.length) {
        this.selectedStagePathId = this.availableStagePaths[0].id
      }
    },

    async fetchAvailableRoles(stagePath) {
      this.loading = true

      try {
        return await this.$services.liveStageWaypointService.getAllAvailableRoles(
          stagePath.liveStageId,
          stagePath.liveCategoryId ? [stagePath.liveCategoryId] : [],
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
